import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import React, { Component } from "react";
import logo from "./imgs/favicon.png";
import { baseStyles, baseColors } from "./components/baseStyles";
import { login } from "./components/general_functions/general";

import "./styles/css/login.css";

export default class LogIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      errorLogingIn: "",
      reCaptcha: false
    };
  }
  
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleLogIn(e) {
    e.preventDefault();
    this.setState({errorLogingIn: "username or password is not correct"});
    let { userName, password } = this.state;
    login(
      { username: userName, password: password },
      res => {
        if (!res.isLoggedIn) {
          this.setState({ errorLogingIn: "Username or Password is wrong" });
          return;
        }
        if (res.user.state !== 2) {
          this.setState({ errorLogingIn: "This user can not login" });
          return;
        }

        if (res) {
          this.setState({errorLogingIn: ""});
          this.props.context.login(res);
        }
      }
    );
  }

  render() {
    let languageId = this.props.context.language;
    return (
      <MuiThemeProvider>
        <div style={styles.wrapper}>
          <div style={styles.container}>
            <div className={"login-wrapper"}>
              <div style={styles.loginContainer}>
                <div style={styles.imageWrapper}>
                  <img
                    src={logo}
                    style={{
                      width: "68%",
                      margin: "48px auto",
                      // border: "3px solid white",
                      borderRadius: 30
                    }}
                  />
                </div>
                <div style={styles.loginContent}>
                  <form
                    style={styles.form}
                    onSubmit={event => this.handleLogIn(event)}
                  >
                    <TextField
                      style={baseStyles.textField}
                      label="Username"
                      value={this.state.username}
                      onChange={this.handleChange('userName')}
                      required
                    />
                    <TextField
                      style={baseStyles.textField}
                      label="Password"
                      type="password"
                      autoComplete="current-password"
                      value={this.state.password}
                      onChange={this.handleChange('password')}
                      required
                    />
                    <div style={{ marginBottom: ""}}>
                      <p
                        style={{ color: baseColors.bgBlue, fontSize: ".8em" }}
                      >
                        {this.state.errorLogingIn}
                      </p>
                    </div>
                    <br />
                    <br />
                    <br />
                    <Button
                      variant="flat"
                      fullWidth={true}
                      root={{
                        backgroundColor: baseColors.bgYallow,
                        height: "100px"
                      }}
                      label={{ color: baseColors.bgGray }}
                      style={{
                        color: baseColors.bgGray,
                        backgroundColor: baseColors.bgYallow,
                        height: 48
                      }}
                      type="submit"
                    >
                      Login
                    </Button>
                  </form>

                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

const styles = {
  wrapper: {
    width: "100%",
    height: "100%",
    marginTop: 32,
    backgroundColor: "white",
    color: baseColors.bgWhite,
    marginTop: 120
  },

  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  loginWrapper: {
    backgroundColor: baseColors.bgWhite,
    width: "30%",
    boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
    borderRadius: 10
  },

  loginContainer: {
    padding: "20px 40px"
  },

  loginHeader: {
    marginBottom: "6%"
  },

  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }
};
